<template>
  <div class="content-5" id="nav-id-1">
    <div class="title-content">
      <div class="title">7日营养菜谱</div>
      <div
        class="save"
        @click="bindSave"
        v-buried
        data-buried="BG_QRCAIPU_BAOCUN"
        v-if="isApp"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_BAOCUN"
        ><span class="iconfont icon-download"></span>保存图片</div
      >
    </div>
    <div class="image-list">
      <img
        class="image-item"
        @click="bindToRecipe(0)"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/19345da27b14e1864e5968a5ab741655.png"
        alt=""
        v-buried
        data-buried="BG_QRCAIPU_ZIZHI_CHAKAN"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_ZIZHII_CHAKAN"
      />
      <img
        class="image-item"
        @click="bindToRecipe(1)"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1913a1519dc761adc91e303e64451efc.png"
        alt=""
        v-buried
        data-buried="BG_QRCAIPU_WAIMAI_CHAKAN"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_WAIMAI_CHAKAN"
      />
    </div>
    <div class="nav-list">
      <div
        class="nav-item"
        @click="bindToDietAdvice"
        v-buried
        data-buried="BG_QRCAIPU_YSJY"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_YSJY"
      >
        <img
          class="item-icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/beeae4d3a1ac058f9ee902689a8fa18a.png"
          alt=""
        />
        <div class="item-text">饮食建议</div>
        <div class="iconfont icon-you"></div>
      </div>
      <div
        class="nav-item"
        @click="bindToDailyGoal"
        v-buried
        data-buried="BG_QRCAIPU_MUBIAO"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_MUBIAO"
      >
        <img
          class="item-icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/37e90d61102f689b3505a99bd1f04311.png"
          alt=""
        />
        <div class="item-text">每日小目标</div>
        <div class="iconfont icon-you"></div>
      </div>
      <div
        class="nav-item"
        @click="bindToDisclaimers"
        v-buried
        data-buried="BG_QRCAIPU_MIANZE"
        v-clickBuried
        data-click-buried="CLICK_QRCAIPU_MIANZE"
      >
        <img
          class="item-icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/aff42f9e4addbaaddc66132b779a1b23.png"
          alt=""
        />
        <div class="item-text">免责声明</div>
        <div class="iconfont icon-you"></div>
      </div>
    </div>
    <!-- 海报 -->
    <CnaPoster ref="poster" :posterType="0" />
  </div>
</template>
<script>
import CnaPoster from './poster.vue'
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  components: {
    CnaPoster
  },
  data() {
    return {
      isApp: false
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
  },
  methods: {
    bindToRecipe(index) {
      this.$router.push({
        path: '/cna-question-v2/recipe',
        query: Object.assign(
          {
            active: index
          },
          this.$route.query
        )
      })
    },
    bindToDietAdvice() {
      this.$router.push('/cna-question-v2/diet-advice')
    },
    bindToDailyGoal() {
      this.$router.push('/cna-question-v2/daily-goal')
    },
    bindToDisclaimers() {
      this.$router.push('/cna-question-v2/disclaimers')
    },
    bindSave() {
      this.$refs.poster.start()
    }
  }
}
</script>
<style lang="scss" scoped>
.content-5 {
  width: 335px;
  padding: 20px;
  margin: 0 auto 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;

  .title-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    .save {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
    }
  }

  .title {
    position: relative;
    z-index: 1;
    display: inline-block;
    font-size: 22px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    height: 28px;
  }

  .title::after {
    position: absolute;
    z-index: -1;
    left: 0;
    bottom: 0;
    content: '';
    width: 100%;
    height: 7px;
    background: linear-gradient(
      270deg,
      rgba(190, 182, 254, 0) 0%,
      #897ffc 100%
    );
    opacity: 0.7;
  }

  .image-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .image-item {
      width: 144px;
      height: 206px;
      background: #edf7f4;
      border-radius: 8px;
    }
  }

  .nav-list {
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;

    .nav-item {
      height: 70px;
      background-color: rgba(244, 246, 250, 0.9);
      margin-bottom: 1px;
      display: flex;
      align-items: center;
      padding: 0px 21px;

      .item-icon {
        width: 37px;
        height: 37px;
        object-fit: contain;
        margin-right: 15px;
      }

      .item-text {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 15px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 21px;
      }
      .iconfont {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.8);
        font-weight: 600;
      }
    }

    .nav-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
